import React from 'react'
import { useHookstate } from '@hookstate/core'
import { useExhibitorDataState } from '../../globalStates/ExhibitorDataState'
import { useLanguageState } from '../../globalStates/LanguageState'
import { makeSetHandlerPlain } from '../../globalStates/utils'
import Section from '../../components/Section'
import KeywordContents from './KeywordContents'

const KeywordsSection: React.FC<{}> = () => {
    const branding = useLanguageState().getStrings()
    const organizationState = useExhibitorDataState().getOrganization()
    const organization = useHookstate(organizationState)

    return (
        <Section title={branding.configuration.profilePage.sctKeywords.title}>
            <KeywordContents value={organization.tags.get()} onChange={makeSetHandlerPlain(organization, 'tags')} />
        </Section>
    );
}

export default KeywordsSection
